import * as api from '../api';

export const getLanguagesFromServer = (slug_id) => {
  const endPoint = `/projects/${slug_id}/languages`;
  return api.get(endPoint);
};
